import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import PropTypes from 'prop-types';
import React, { useContext, useMemo } from 'react';
import { IntlContext, IntlProvider as IntlProvider$1, useIntl, FormattedMessage } from 'react-intl';
import { useLocales, LocalesProvider, useResource } from '@panneau/core/contexts';
import { PropTypes as PropTypes$1 } from '@panneau/core';

var IntlManager = /*#__PURE__*/function () {
  function IntlManager() {
    _classCallCheck(this, IntlManager);
    this.locales = [];
  }
  return _createClass(IntlManager, [{
    key: "addLocale",
    value: function addLocale(locale, messages) {
      var replace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var currentLocale = this.getLocale(locale);
      this.locales = [].concat(_toConsumableArray(currentLocale !== null ? this.locales.filter(function (it) {
        return it.locale !== locale;
      }) : this.locales), [{
        locale: locale,
        messages: currentLocale !== null && !replace ? _objectSpread(_objectSpread({}, currentLocale.messages), messages) : messages
      }]);
    }
  }, {
    key: "getLocale",
    value: function getLocale(locale) {
      return this.locales.find(function (it) {
        return it.locale === locale;
      }) || null;
    }
  }, {
    key: "hasLocale",
    value: function hasLocale(locale) {
      return this.getLocale(locale) !== null;
    }
  }, {
    key: "getMessages",
    value: function getMessages(locale) {
      var _ref = this.locales.find(function (it) {
          return it.locale === locale;
        }) || {},
        _ref$messages = _ref.messages,
        messages = _ref$messages === void 0 ? null : _ref$messages;
      return messages;
    }
  }]);
}();

var intlManager = new IntlManager();

var propTypes$1 = {
  intlManager: PropTypes.instanceOf(IntlManager),
  locale: PropTypes.string,
  locales: PropTypes.arrayOf(PropTypes.string),
  extraMessages: PropTypes.objectOf(PropTypes.string),
  children: PropTypes.node
};
var defaultProps$1 = {
  intlManager: intlManager,
  locale: null,
  locales: null,
  extraMessages: null,
  children: null
};
var IntlProvider = function IntlProvider(_ref) {
  var intlManager = _ref.intlManager,
    locale = _ref.locale,
    locales = _ref.locales,
    children = _ref.children,
    extraMessages = _ref.extraMessages;
  var previousLocales = useLocales();
  var _ref2 = useContext(IntlContext) || {},
    _ref2$locale = _ref2.locale,
    previousLocale = _ref2$locale === void 0 ? null : _ref2$locale,
    _ref2$messages = _ref2.messages,
    previousMessages = _ref2$messages === void 0 ? null : _ref2$messages;
  var managerMessages = intlManager !== null ? intlManager.getMessages(locale) : null;
  var messages = useMemo(function () {
    return _objectSpread(_objectSpread(_objectSpread({}, previousLocale === locale ? previousMessages : null), managerMessages), extraMessages);
  }, [managerMessages, locale, previousLocale, previousMessages, extraMessages]);
  return /*#__PURE__*/React.createElement(IntlProvider$1, {
    locale: locale,
    messages: messages
  }, /*#__PURE__*/React.createElement(LocalesProvider, {
    locales: locales || previousLocales
  }, children));
};
IntlProvider.propTypes = propTypes$1;
IntlProvider.defaultProps = defaultProps$1;

var propTypes = {
  resource: PropTypes$1.resource,
  values: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types,
  id: PropTypes.string.isRequired,
  defaultMessage: PropTypes.string,
  description: PropTypes.string
};
var defaultProps = {
  resource: null,
  values: null,
  defaultMessage: null,
  description: null
};
var ResourceMessage = function ResourceMessage(_ref) {
  var resource = _ref.resource,
    values = _ref.values,
    id = _ref.id,
    defaultMessage = _ref.defaultMessage,
    description = _ref.description;
  var contextResource = useResource();
  var _useIntl = useIntl(),
    messages = _useIntl.messages;
  var _ref2 = resource || contextResource || {},
    resourceId = _ref2.id,
    _ref2$name = _ref2.name,
    name = _ref2$name === void 0 ? null : _ref2$name,
    _ref2$intl = _ref2.intl,
    _ref2$intl2 = _ref2$intl === void 0 ? {} : _ref2$intl,
    resourceValues = _ref2$intl2.values;
  var resourceMessageId = id.replace(/^resources\./, "resources.".concat(resourceId, "."));
  var message = {
    id: typeof messages[resourceMessageId] !== 'undefined' ? resourceMessageId : id,
    defaultMessage: defaultMessage,
    description: description
  };
  return /*#__PURE__*/React.createElement(FormattedMessage, Object.assign({
    values: _objectSpread(_objectSpread({
      name: name
    }, resourceValues), values)
  }, message));
};
ResourceMessage.propTypes = propTypes;
ResourceMessage.defaultProps = defaultProps;

var useResourceValues = function useResourceValues(resource) {
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var contextResource = useResource();
  var allValues = useMemo(function () {
    var _ref = resource || contextResource || {},
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? null : _ref$name,
      _ref$intl = _ref.intl,
      _ref$intl2 = _ref$intl === void 0 ? {} : _ref$intl,
      resourceValues = _ref$intl2.values;
    return _objectSpread(_objectSpread({
      name: name
    }, resourceValues), values);
  }, [resource, values, contextResource]);
  return allValues;
};

export { IntlManager, IntlProvider, ResourceMessage, intlManager as default, useResourceValues };
